import React from "react";
import { Route, Routes } from "react-router-dom";
import HomeController from "./pages/home/controllers/Home.controller";
import AboutController from "./pages/about/controllers/About.controller";
import SkillsController from "./pages/skills/controllers/Skills.controller";
import ContactController from "./pages/contact/controllers/Contact.controller";
import TestimonialsController from "./pages/testimonials/controllers/Testimonials.controller";
import HomeView from "./pages/home/views/Home.view";
import AboutView from "./pages/about/views/About.view";
import SkillsView from "./pages/skills/views/Skills.view";
import ContactView from "./pages/contact/views/Contact.view";
import TestimonialsView from "./pages/testimonials/views/Testimonials.view";
import NotFoundView from "./pages/notfound/NotFound.view";

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<HomeView {...HomeController()} />} />
      <Route path="/about" element={<AboutView {...AboutController()} />} />
      <Route path="/skills" element={<SkillsView {...SkillsController()} />} />
      <Route
        path="/contact"
        element={<ContactView {...ContactController()} />}
      />
      <Route
        path="/testimonials"
        element={<TestimonialsView {...TestimonialsController()} />}
      />
      <Route path="*" element={<NotFoundView />} />
    </Routes>
  );
};

export default AppRoutes;
